import { isRef, onUnmounted, type Ref, unref, watch } from 'vue'

export function useResizeObserver(target: Ref<Element | undefined | null> | Element, callback: (rect: DOMRectReadOnly, target: Element) => void) {
  let observer: ResizeObserver | undefined
  const el = unref(target)
  if (el) {
    observer = new ResizeObserver(([entry]) => callback(entry.contentRect, entry.target))
    observer.observe(el)
  }

  const cleanup = () => {
    observer?.disconnect()
    observer = undefined
  }

  if (isRef(target)) {
    watch(
      target,
      (el) => {
        cleanup()
        if (el) {
          observer = new ResizeObserver(([entry]) => callback(entry.contentRect, entry.target))
          observer.observe(el)
        }
      },
      { flush: 'post' },
    )
  }

  onUnmounted(cleanup)
}
